import CustomDrawer from "@/components/drawer";
import SelectFromCalendar from "@/modules/schedule/calendar";
import useScheduleStore from "@/store/schedule";
import { ActionIcon, Button, Group, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCalendar } from "@tabler/icons-react";
import moment from "moment-jalaali";

export function TimSelectorHeader() {
  const { selectedAppointmentDate, setSelectedAppointmentDate } =
    useScheduleStore();
  const [openedCalender, { open: openCalender, close: closeCalender }] =
    useDisclosure(false);

  return (
    <>
      <Group justify="space-between" align="center" pt="5" px="md">
        <Text size="sm">
          {moment(selectedAppointmentDate)?.format("dddd jD jMMMM jYYYY")}
        </Text>

        <Button size="xs" onClick={openCalender} variant="light" px="5">
          <Group gap="5">
            <Text size="xs">انتخاب تاریخ</Text>
            <ActionIcon onClick={openCalender} variant="transparent">
              <IconCalendar stroke={1} />
            </ActionIcon>
          </Group>
        </Button>
      </Group>
      <CustomDrawer
        opened={openedCalender}
        close={closeCalender}
        onClose={closeCalender}
        position="bottom"
        title="انتخاب تاریخ"
      >
        <Stack pt="md">
          <SelectFromCalendar
            minDate
            close={closeCalender}
            setDate={(e) =>
              setSelectedAppointmentDate({
                selectedAppointmentDate: e,
              })
            }
          />
        </Stack>
      </CustomDrawer>
    </>
  );
}
